import React from "react";
import styled from "styled-components/macro";
import { LBFooter } from "components";

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Work Sans;
  width: 100vw;
  justify-content: center;
  align-items: center;
`;

const HeaderWrapper = styled.div`
  width: 100vw;
  background-color: #FAFAFA;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentWrapper = styled.div`
  width: 100vw;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterContainer = styled.div`
  margin: 2em 0;
  background-color: #F7F7F7;
  padding-left: 6em;
`;

const Layout = ({ header, content, children }) => (
  <LayoutWrapper>
    <BodyContainer>
      <HeaderWrapper>{header}</HeaderWrapper>
      <ContentWrapper>{content}</ContentWrapper>
      {children}
    </BodyContainer>
    <FooterContainer>
      <LBFooter />
    </FooterContainer>
  </LayoutWrapper>
);

export default Layout;
